import React from "react";

import { DonateContainer, DonateForm, DonateInput, DonameImg } from "./donateBarElements";

const DonateSection = ({ isDiv }) => {
  return (
    <DonateContainer isDiv={isDiv}>
      <DonateForm action="https://www.paypal.com/donate" method="post" target="_top">
        <DonateInput type="hidden" name="hosted_button_id" value="WWW4AV2A78438" />
        <DonateInput
          type="image"
          src="https://www.paypalobjects.com/en_US/FR/i/btn/btn_donateCC_LG.gif"
          name="submit"
          title="PayPal - The safer, easier way to pay online!"
          alt="Donate with PayPal button"
        />
        <DonameImg alt="" border="0" src="https://www.paypal.com/en_FR/i/scr/pixel.gif" />
      </DonateForm>
    </DonateContainer>
  );
};

export default DonateSection;
